
// Predefined list of subjects for filtering
export const worksheetSubjects = [
  "Mathematics", "Math", "Science", "Physics", "Chemistry", "Biology",
  "English", "Thai", "Social Studies", "History", "Geography",
  "Computer Science", "Physical Education", "Arts", "Music"
];
